import { ColorX } from "IZOX/STATIC";

const Styles = {
  QFText: {
    bColor: ColorX.CSS("Gray4"),
    disabled_bgColor: ColorX.CSS("NotQuiteWhite"),
    textAlign: "[",
    fontSize: 14,
    p: 12
  },
  QFBtn: {
    bgColor: ColorX.CSS("Axit"),
    showLoading: true,
    color: ColorX.CSS("pureWhite"),
    round: 50,
    delayAfterPress: 1000
  },
  QFBtnInverse: {
    bgColor: ColorX.CSS("transparent"),
    showLoading: true,
    color: ColorX.CSS("Axit"),
    bW: 1,
    style: {
      borderColor: ColorX.CSS("Axit")
    },
    round: 50,
    delayAfterPress: 1000
  },
  QFBtnCancel: {
    color: ColorX.CSS("Leaf"),
    round: 50,
    delayAfterPress: 1000
  }
};

export default Styles;